import React, { useState, useEffect } from "react";
import { Container, Grid, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import {
  CustomTitle,
  CustomLabel,
} from "../../components/Custom/CustomTypography";
import CustomTabs from "../../components/Custom/CustomTabs"; // Import the CustomTabs component
import { useNavigate } from "react-router-dom";
import CustomCardStatus from "../../components/Custom/CustomCardStatus";

const BidsAndTrades = () => {
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [bids, setBids] = useState([]);
  const [requirements, setRequirements] = useState([]);

  const fetchBidsList = async () => {
    try {
      const response = await api.get("/buyer/expression-of-interest/");
      console.log(response.data);
      setBids(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Bids list:", error);
      setLoading(false);
    }
  };

  const fetchRequirementsList = async () => {
    try {
      const response = await api.get("/buyer/requirements/");
      console.log(response.data);
      setRequirements(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching requirements list:", error);
      setLoading(false);
    }
  };

  const handleBidCardClick = (bidId) => {
    navigate(`/buyer/bids-trades/bid?interest_id=${bidId}`);
  };

  const handleRequirementCardClick = (reqId) => {
    navigate(`/buyer/bids-trades/requirement?req_id=${reqId}`);
  };

  useEffect(() => {
    fetchBidsList();
    fetchRequirementsList();
  }, []);

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <>
          <Container maxWidth="xs">
            <CustomTitle>{t("My bids and trades")}</CustomTitle>

            <Box sx={{ marginTop: "10px" }}>
              <CustomTabs
                numTabs={2}
                tabTitles={[t("Bids"), t("Requirements")]}
                counts={[bids.length, requirements.length]}
                onTabChange={setActiveTab}
                textColors={["black", "black"]}
              />
            </Box>
            {activeTab === 0 ? (
              <>
                {bids && bids.length !== 0 ? (
                  <Grid container>
                    <div
                      style={{
                        height: "93%",
                        width: "100%",
                        // overflowY: "scroll",
                        marginTop: "10px",
                      }}
                    >
                      {bids.map((bid) => (
                        <div key={bid.id} style={{ width: "99%" }}>
                          <CustomCardStatus
                            status={bid.status}
                            title={`${bid.commodity.name}`}
                            subtitle={`${bid.quantity} MT, 
                              ${bid.district.name},
                              ${bid.date}`}
                            onClick={() => handleBidCardClick(bid.id)}
                          />
                        </div>
                      ))}
                    </div>
                  </Grid>
                ) : (
                  <div
                    style={{
                      height: "60vh",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CustomLabel>{t("No Bids Data Found")}</CustomLabel>
                  </div>
                )}
              </>
            ) : (
              <>
                {requirements && requirements.length !== 0 ? (
                  <Grid container>
                    <div
                      style={{
                        height: "93%",
                        width: "100%",
                        // overflowY: "scroll",
                        marginTop: "10px",
                      }}
                    >
                      {requirements.map((requirement) => (
                        <div key={requirement.id} style={{ width: "99%" }}>
                          <CustomCardStatus
                            status={requirement.fulfilled}
                            title={`${requirement?.commodity?.name}`}
                            subtitle={`${requirement.quantity} MT,
                              ${requirement.district.name},
                              ${requirement.date_needed}`}
                            onClick={() =>
                              handleRequirementCardClick(requirement.id)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </Grid>
                ) : (
                  <div
                    style={{
                      height: "60vh",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CustomLabel>{t("No Requirements Data Found")}</CustomLabel>
                  </div>
                )}
              </>
            )}
          </Container>
        </>
      </LoaderContainer>
    </>
  );
};

export default BidsAndTrades;
